import React from "react";
import classes from "./CommonCard.module.css";

const CommonCard = ({ children, className, ...rest }) => {
  return (
    <div className={[classes["commonCard"], className].join(" ")} {...rest}>
      {children}
    </div>
  );
};

export default CommonCard;
